import React, {useEffect, useState} from 'react'
import {Button} from "primereact/button";
import {getFromLocalStorageWithDefault} from "../../../../util/localStorageZugriff";
import GasteingabeSpiele from "./GasteingabeSpiele";
import GasteingabeMannschaft from "./GasteingabeMannschaft";

const REITER = [
    {id: "spiele", label: "Spiele", icon: "pi pi-th-large"},
    {id: "mannschaft", label: "Mannschaft", icon: "pi pi-users"},
];

/**
 * Eingabe der Gastmannschaft beim Ligaspieltag im neuen Design. Entspricht inhaltlich
 * PublicLigaspielttagGastmannschaftInput der alten Ansicht, die dort unverändert verwendet wird.
 */
export default function GasteingabeDialog({aktuellerBereich, onRefresh, onClose}) {

    const gastInput = getFromLocalStorageWithDefault("dh_ligaspieltag_gast_input", undefined);

    const [reiter, setReiter] = useState("spiele");
    const [refreshCounter, setRefreshCounter] = useState(1);

    // wechselt der Veranstalter den Bereich (Phase), die Spiele neu laden
    useEffect(() => {
        setRefreshCounter(counter => counter + 1);
    }, [aktuellerBereich]);

    useEffect(() => {
        // die Seite dahinter soll nicht mitscrollen
        const overflowVorher = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = overflowVorher;
        };
    }, []);

    const aktualisieren = () => {
        setRefreshCounter(counter => counter + 1);
        onRefresh();
    }

    const getInhalt = () => {
        if (gastInput === undefined || gastInput === null) {
            return <p className="dhpt-hinweis">Es ist keine Gasteingabe hinterlegt. Bitte scanne den QR-Code der Gastmannschaft erneut.</p>
        }
        if (reiter === "mannschaft") {
            return <GasteingabeMannschaft tournamentid={gastInput.tournamentid} qrcode={gastInput.qrcode}/>
        }
        return <GasteingabeSpiele tournamentid={gastInput.tournamentid} qrcode={gastInput.qrcode} counter={refreshCounter}/>
    }

    return <div className="dhpt-vollbild dhpt-gast" role="dialog" aria-modal="true" aria-label="Eingabe Gastmannschaft">
        <div className="dhpt-vollbild-leiste">
            <span className="dhpt-vollbild-titel">Eingabe Gastmannschaft</span>
            <Button icon="pi pi-refresh" label="Aktualisieren" className="p-button-sm p-button-outlined dhpt-button-hell dhpt-gast-leisten-knopf"
                    onClick={aktualisieren}/>
            <Button icon="pi pi-times" label="Schließen" className="p-button-sm p-button-secondary dhpt-gast-leisten-knopf" onClick={() => onClose()}/>
        </div>
        <div className="dhpt-vollbild-inhalt">
            <div className="dhpt-gast-inhalt">
                <div className="dhpt-segment" role="radiogroup" aria-label="Bereich der Gasteingabe">
                    {REITER.map(r => <button key={r.id} type="button" role="radio" aria-checked={reiter === r.id}
                                             className="dhpt-segment-knopf" onClick={() => setReiter(r.id)}>
                        <i className={r.icon} aria-hidden="true"/><span>{r.label}</span>
                    </button>)}
                </div>
                {getInhalt()}
            </div>
        </div>
    </div>
}
